"use client";

import React, { useState } from "react";
import "./Navbar.css";
import Link from "next/link";
import closeIcon from "@/assets/icons/closeBlack.svg";
import Image from "next/image";
const NavChevron = React.lazy(() => import("@/assets/svgs/NavChevron"));

function SidebarRight({ isSidebarRightOpen, setIsSidebarRightOpen }) {
  const [isServiceOpen, setIsServiceOpen] = useState(false);
  const [isAboutUsOpen, setIsAboutUsOpen] = useState(false);

  const toggleService = () => setIsServiceOpen((prev) => !prev);
  const toggleAboutUs = () => setIsAboutUsOpen((prev) => !prev);

  return (
    <div
      className={`sidebarRight ${isSidebarRightOpen ? "open" : ""} `}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="Sidebar-wrapper">
        <Image
          src={closeIcon}
          alt="Schließen"
          className="SidebarRight-close"
          onClick={() => setIsSidebarRightOpen(false)}
        />
        <ul className="nav-links">
          <li onClick={() => setIsSidebarRightOpen(false)}>
            <Link href="/auto-bewerten" className="links">
              Auto bewerten
            </Link>
          </li>
          <li onClick={() => setIsSidebarRightOpen(false)}>
            <Link href="/auto-verkaufen" className="links">
              Auto verkaufen
            </Link>
          </li>
          <li onClick={() => setIsSidebarRightOpen(false)}>
            <Link href="/so-funktionierts" className="links">
              So funktioniert’s
            </Link>
          </li>

          <li
            className={`dropdown-sidebar ${isServiceOpen ? "active" : ""}`}
            onClick={toggleService}
          >
            <div className="dropdown-sidebar-title-wrapper">
              <span className="links">Service</span>
              <NavChevron
                alt="chevron"
                className={`nav-chevron ${isServiceOpen ? "active" : ""}`}
              />
            </div>
            {isServiceOpen && (
              <ul className="dropdown-sidebar-menu">
                <li onClick={() => setIsSidebarRightOpen(false)}>
                  <Link
                    href="/auto-bewerten/listenpreis-auto"
                    className="dropdown-sidebar-links"
                  >
                    Listenpreis Auto
                  </Link>
                </li>
                <li onClick={() => setIsSidebarRightOpen(false)}>
                  <Link
                    href="/fahrgestellnummer-pruefen"
                    className="dropdown-sidebar-links"
                  >
                    Fahrgestellnummer prüfen
                  </Link>
                </li>
                <li onClick={() => setIsSidebarRightOpen(false)}>
                  <Link
                    href="/kaputtes-auto-verkaufen"
                    className="dropdown-sidebar-links"
                  >
                    Kaputtes Auto Verkaufen
                  </Link>
                </li>
              </ul>
            )}
          </li>

          {/* Über uns dropdown-sidebar */}
          <li
            className={`dropdown-sidebar ${isAboutUsOpen ? "active" : ""}`}
            onClick={toggleAboutUs}
          >
            <div className="dropdown-sidebar-title-wrapper">
              <span className="links">Über uns</span>

              <NavChevron
                alt="chevron"
                className={`nav-chevron ${isAboutUsOpen ? "active" : ""}`}
              />
            </div>
            {isAboutUsOpen && (
              <ul className="dropdown-sidebar-menu">
                <li onClick={() => setIsSidebarRightOpen(false)}>
                  <Link href="/ueber-uns" className="dropdown-sidebar-links">
                    Über uns
                  </Link>
                </li>
                <li onClick={() => setIsSidebarRightOpen(false)}>
                  <Link href="/ratgeber" className="dropdown-sidebar-links">
                    Ratgeber
                  </Link>
                </li>
                <li onClick={() => setIsSidebarRightOpen(false)}>
                  <Link href="/faq" className="dropdown-sidebar-links">
                    Häufige Fragen
                  </Link>
                </li>

                <li onClick={() => setIsSidebarRightOpen(false)}>
                  <Link
                    href="/kontaktiere-uns"
                    className="dropdown-sidebar-links"
                  >
                    Kontaktiere uns
                  </Link>
                </li>
              </ul>
            )}
          </li>
        </ul>
      </div>
    </div>
  );
}

export default SidebarRight;
